/**
 * @generated SignedSource<<d245905314342b1a974b803c1f0279c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteActivityInput = {
  clientMutationId?: string | null;
  id: string;
  notifyParticipants?: boolean | null;
};
export type FeedDeleteDialogMutation$variables = {
  input: DeleteActivityInput;
};
export type FeedDeleteDialogMutation$data = {
  readonly deleteActivity: {
    readonly deletedActivityId: string;
  } | null;
};
export type FeedDeleteDialogMutation = {
  response: FeedDeleteDialogMutation$data;
  variables: FeedDeleteDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteActivityPayload",
    "kind": "LinkedField",
    "name": "deleteActivity",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedActivityId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeedDeleteDialogMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeedDeleteDialogMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "832dfc113ac135c63f5c2de941b67629",
    "id": null,
    "metadata": {},
    "name": "FeedDeleteDialogMutation",
    "operationKind": "mutation",
    "text": "mutation FeedDeleteDialogMutation(\n  $input: DeleteActivityInput!\n) {\n  deleteActivity(input: $input) {\n    deletedActivityId\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9be61c0269cbd383a9ba56f61f61945";

export default node;
